export const REGEX_VALID_IMAGE = /^https:\/\/[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+(?:\/[a-zA-Z0-9._-]+)*\.(jpeg|jpg|gif|png|webp|svg)$/;
